import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default function Delivery(props) {
  return (
    <SvgIcon viewBox="0 0 18 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1.25C0 0.835786 0.335786 0.5 0.75 0.5H12C12.4142 0.5 12.75 0.835786 12.75 1.25V11C12.75 11.4142 12.4142 11.75 12 11.75H0.75C0.335786 11.75 0 11.4142 0 11V1.25ZM1.5 2V10.25H11.25V2H1.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 5C11.25 4.58579 11.5858 4.25 12 4.25H15C15.1989 4.25 15.3897 4.32902 15.5303 4.46967L17.7803 6.71967C17.921 6.86032 18 7.05109 18 7.25V11C18 11.4142 17.6642 11.75 17.25 11.75H12C11.5858 11.75 11.25 11.4142 11.25 11V5ZM12.75 5.75V10.25H16.5V7.56066L14.6893 5.75H12.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.125 11.75C3.50368 11.75 3 12.2537 3 12.875C3 13.4963 3.50368 14 4.125 14C4.74632 14 5.25 13.4963 5.25 12.875C5.25 12.2537 4.74632 11.75 4.125 11.75ZM1.5 12.875C1.5 11.4253 2.67525 10.25 4.125 10.25C5.57475 10.25 6.75 11.4253 6.75 12.875C6.75 14.3247 5.57475 15.5 4.125 15.5C2.67525 15.5 1.5 14.3247 1.5 12.875Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.875 11.75C13.2537 11.75 12.75 12.2537 12.75 12.875C12.75 13.4963 13.2537 14 13.875 14C14.4963 14 15 13.4963 15 12.875C15 12.2537 14.4963 11.75 13.875 11.75ZM11.25 12.875C11.25 11.4253 12.4253 10.25 13.875 10.25C15.3247 10.25 16.5 11.4253 16.5 12.875C16.5 14.3247 15.3247 15.5 13.875 15.5C12.4253 15.5 11.25 14.3247 11.25 12.875Z"
      />
    </SvgIcon>
  );
}
